import saveManager from '../utils/SaveManager';
import audioEditorUtils from '../audioEditor/utils/AudioEditorUtils';
import React from 'react';
import { MenuCheckbox, MenuInput } from './SizeAndPositionButtons';
import { updateCurrentSlideThumbnail, updateShapeSize } from '../../actions/CurrentSlideActions';
import locales from '../../locales/LocalesManager';
import storeManager from '../../store/StoreManager';
import { connect } from 'react-redux';

export const ResizeViewContent = React.createClass({
    getInitialState() {
        const shapeModel = this.getContextTarget();

        return {
            width: shapeModel.width,
            height: shapeModel.height,
            lockedRatio: true
        };
    },
    componentWillReceiveProps: function(nextProps) {
        if (this.props.refreshShapePosition != nextProps.refreshShapePosition) {
            var contextTarget = this.getContextTarget();

            this.setState({width: contextTarget.width, height: contextTarget.height});
        }
    },
    getContextTarget() {
        const shapes = storeManager.getState().currentSlide.model.content;

        for (let i = 1; i < shapes.length; i++) {
            if (shapes[i].uuid === this.props.shapeModel.uuid)
                return shapes[i];
        }

        return this.props.shapeModel;
    },
    updateAttribute(name, value) {
        const shapeModel = this.getContextTarget();
        if (!shapeModel) {
            return;
        }

        value = parseInt(value);
        let isChanged = false;
        const absoluteValue = Math.abs(value) || 0;
        const lockedRatio = this.state.lockedRatio;

        switch (name) {
            case 'width': {
               if (shapeModel.width !== absoluteValue) {
                   const height = lockedRatio && this.state.height ?
                       (absoluteValue / (this.state.width)) * this.state.height :
                       this.state.height+0.1;

                   if (height !== this.state.height || absoluteValue !== this.state.width) {
                       this.setState({width: absoluteValue, height});
                   }

                   isChanged = true;
                    this.props.dispatch(updateShapeSize(shapeModel.uuid, absoluteValue, height, shapeModel.x, shapeModel.y));
                }
                break;
            }
            case 'height': {
                if (shapeModel.height !== absoluteValue) {
                    const width = lockedRatio && this.state.width ?
                        (absoluteValue / (this.state.height)) * this.state.width:
                        this.state.width+0.1;

                    if (width !== this.state.width || absoluteValue !== this.state.height) {
                        this.setState({height: absoluteValue, width});
                    }
                    isChanged = true;
                    this.props.dispatch(updateShapeSize(shapeModel.uuid, width, absoluteValue, shapeModel.x, shapeModel.y));
                }
                break;
            }
        }

        if (isChanged) {
            saveManager.isContentChanged(true);
            audioEditorUtils.addActionToHistory();
            this.props.dispatch(updateCurrentSlideThumbnail(true));
            this.forceUpdate();
        }
    },
    onCheckBoxClick() {
        this.setState({
            lockedRatio: !this.state.lockedRatio
        });
    },
    render() {
        const smallTextStyle = {
            fontSize: '12px',
            marginTop: '15px',
            marginBottom: '-5px'
        };

        const buttonWrapperStyle = {
            display: 'flex',
            flexWrap: 'wrap',
            marginTop: '10px',
            justifyContent: 'space-between'
        };

        return (
            <div>
                <h3 style={smallTextStyle}>{locales.getCaption('Size', 'sizePosMenu')}</h3>

                <div style={buttonWrapperStyle}>
                    <MenuInput isInt={true} labelText={locales.getCaption('Width', 'sizePosMenu')} value={this.state.width} property={'width'} onChangeHandler={this.updateAttribute}/>
                    <MenuInput isInt={true} labelText={locales.getCaption('Height', 'sizePosMenu')} value={this.state.height} property={'height'} onChangeHandler={this.updateAttribute}/>

                    <MenuCheckbox id="resizeLastItem" labelText={locales.getCaption('LockRatio', 'sizePosMenu')} value={this.state.lockedRatio} clickHandler={this.onCheckBoxClick}/>
                </div>
            </div>
        )
    }
});

function mapStateToProps () {
    const state = storeManager.getState();
    var refreshShapePosition = state.menu.refreshShapePosition;

    return {
        refreshShapePosition
    };
}

export const ResizeView = connect(mapStateToProps)(ResizeViewContent);


/** WEBPACK FOOTER **
 ** ./src/components/menus/ResizeView.js
 **/